<template>
  <div v-if="shares">
    <div style="" class="p-3 text-center">
      <div class="">
        <button v-if="!shares.state" :disabled="block" @click="toggleButton()" class="btn btn-success">Включить</button>
        <button v-if="shares.state" :disabled="block" @click="toggleButton()" class="btn btn-danger">Выключить</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Proxmox",

  props: ["info", "shares", "id", "remote", "config"],
  data: function () {
    return {
      block: false,
    };
  },
  methods: {
    async toggleButton() {
      this.block = true;
      try {
        this.remote.commandPromise("dashboardDeviceAction", {
          dashboard: this.config.dashboard,
          action: "toggle",
          device: this.id,
          push: {},
        });
      } catch (e) {
        console.log(e);
      }
      this.block = false;
    },
  },
};
</script>
<style scoped>
</style>
